import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-design-color-icon',
  templateUrl: './design-color.component.html'
})
export class DesignColorComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
